import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import FormFields from './FormField';
import { CouponFormData } from './CouponFormPage';

interface CouponFormProps {
  mode: 'create' | 'edit';
  id?: string;
  fetchCoupon: (id: string) => Promise<any>;
  onSubmit: (data: CouponFormData) => Promise<void>;
}

export default function CouponForm({
  mode,
  id,
  fetchCoupon,
  onSubmit,
}: CouponFormProps) {
  const [loading, setLoading] = useState(mode === 'edit');

  const [form, setForm] = useState<CouponFormData>({
    code: '',
    promoType: 'FIXED',
    appliedOn: 'ALL',
    channel: 'ALL',
    amount: '',
    bookingFrom: '',
    bookingUntil: '',
    maxUsage: '',
    maxUsagePerUser: '',
  });

  useEffect(() => {
    if (mode === 'edit' && id) {
      fetchCoupon(id).then((data) => {
        if (data) {
          setForm({
            code: data.code,
            promoType: data.type,
            appliedOn: (data.appliedOn ?? 'ALL') as CouponFormData['appliedOn'],
            channel: (data.channel ?? 'ALL') as CouponFormData['channel'],
            amount: data.amount?.toString(),
            bookingFrom: data.startsAt.substring(0, 10),
            bookingUntil: data.endsAt.substring(0, 10),
            maxUsage: data.totalLimit?.toString() ?? '',
            maxUsagePerUser: data.perUserLimit?.toString() ?? '',
          });
        }
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [mode, id, fetchCoupon]);

  const update = (field: keyof CouponFormData, value: any) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <FormFields form={form} update={update} mode={mode} />

      <Box display="flex" justifyContent="flex-end" gap={2} mt={2} mb={4}>
        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit(form)}
        >
          {mode === 'edit' ? 'Save Changes' : 'Create Coupon'}
        </Button>
      </Box>
    </Box>
  );
}
